module.exports = __webpack_public_path__ + "static/media/tool.57a473f0.svg";